export default "__VITE_ASSET__f51678d1__"